import React from 'react'
import styled from 'styled-components'
import { zIndexes } from 'frontend_core/dist/styles/variables'
import ServiceMessages from 'components/shared/header/ServiceMessages'
import NotificationList from 'components/shared/header/NotificationList'
import ToDoList from 'components/shared/header/ToDoList'

type PropTypes = {
  config: Object,
  currentUser: Object,
  notifications: Array<Object>,
  display: number,
  actions: {
    setUIState: Function,
  },
}

const Notification = styled.div`
  box-sizing: border-box;
  padding-top: 44px;
  background: #fff;
  width: 100vw;
  height: 100vh;
  z-index: ${zIndexes.main};
  overflow-x: scroll;
`

class MobileNotification extends React.Component<PropTypes> {
  render() {
    const { ui, localUser, data, config } = this.props
    return (
      <Notification>
        <ServiceMessages
          currentUser={data.viewer}
          announcements={localUser.announcements}
        />
        <ToDoList currentUser={data.viewer} todoItems={localUser.todoItems} />
        <NotificationList
          config={config}
          currentUser={data.viewer}
          notifications={localUser.notifications}
          display={ui.numberDisplay}
        />
      </Notification>
    )
  }
}

export default MobileNotification



// WEBPACK FOOTER //
// ./src/components/shared/header/MobileNotification.jsx